import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { ActivatedRoute } from '@angular/router';
import { formatAmount } from '../shared/constants';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss', '../../assets/styles/dashboard-styles.scss']
})
export class DashboardComponent implements OnInit {
	constructor(private apiService: ApiService, private activeRoute: ActivatedRoute) { }

	ngOnInit(): void { }
}
